import React, { useState, useEffect, useContext } from "react";
import axios from "axios"; // Import axios
import SidebarItem from "../SidebarItem/SidebarItem";
import Divider from "../Divider/Divider";
import { AuthContext } from "../AuthContext/AuthContext";
import "./Sidebar.css";

import Home from "../../resources/images/Navigation/Home.svg";
import Chat from "../../resources/images/Navigation/Chat.svg";
import QualityCheckerConnection from "../../resources/images/Navigation/Quality-checker-configuration.svg";
import Search from "../../resources/images/Navigation/Search.svg";
import ExtendScreen from "../../resources/images/Navigation/Expand-menu.svg";
import QualityChecker from "../../resources/images/Navigation/Quality-checker.svg";
import DataCollection from "../../resources/images/Navigation/Data-collections.svg";
import Logo from "../../resources/images/Logo_Roche.png";
import Logout from "../../resources/images/icons/logout.svg";
import DRR from "../../resources/images/Navigation/drr_icon.svg";
//import ProfileIcon from "../../resources/images/icons/profile.svg";
import { API_BASE_URL } from "../../apiConfig";

function Sidebar() {
  const { token } = useContext(AuthContext) || {};
  const [isExpanded, setIsExpanded] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [userData, setUserData] = useState({
    user: "",
    is_authenticated: false,
  });

  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error("AuthContext not found");
  }

  const { logout } = authContext;

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/auth/user`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });
        if (response.status === 200) {
          setUserData(response.data);
        } else {
          console.error("Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const toggleSidebar = () => {
    setIsExpanded(!isExpanded);
    if (isProfileMenuOpen) setIsProfileMenuOpen(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = "/login";
    } catch (error) {
      console.error("Logout failed:", error);
      alert("Logout failed. Please try again.");
    }
  };

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  return (
    <div className={`sidebar ${isExpanded ? "expanded" : "collapsed"}`}>
      <div className="sidebar-items">
        <div className="sidebar-logo">
          <a href="https://staging.dca.roche.com/" className="logo-link">
            <img src={Logo} alt="Roche Logo" />
          </a>
          {isExpanded && <span>Diabetes Care Assistant</span>}
        </div>
        <SidebarItem
          icon={Home}
          label="Home"
          path="/"
          isExpanded={isExpanded}
        />
        <SidebarItem
          icon={Chat}
          label="Chat"
          path="/chat"
          isExpanded={isExpanded}
        />
        <Divider />
        {/* <SidebarItem
          icon={DataCollection}
          label="Data Collection"
          path="/data-collection"
          isExpanded={isExpanded}
        /> */}
      </div>

      <div className="sidebar-lower">
        <div className="user-profile-section">
          <div className="user-profile" onClick={toggleProfileMenu}>
            {/* <div className="user-image">
              {userData.user ? (
                <img
                  src="https://via.placeholder.com/40"
                  alt="User"
                  className="user-image-circle"
                />
              ) : (
                <div className="user-image-placeholder"></div>
              )}
            </div> */}
            {/* {isExpanded && (
              <div className="user-info">
                <span className="user-name">
                  {userData.user || "User Name"}
                </span>
                <span className="user-email">
                  {userData.user
                    ? `${userData.user}@roche.com`
                    : "user@roche.com"}
                </span>
              </div>
            )} */}
          </div>

          {isProfileMenuOpen && (
            <div
              className={`profile-dropdown ${
                isExpanded ? "expanded" : "collapsed"
              }`}
            >
              <button className="dropdown-item">
                <SidebarItem
                  icon={Logo}
                  label="Profile"
                  isExpanded={true}
                  className="dropdown-item-button"
                />
              </button>
              <button onClick={handleLogout} className="dropdown-item">
                <SidebarItem
                  icon={Logout}
                  label="Logout"
                  isExpanded={true}
                  className="dropdown-item-button"
                />
              </button>
            </div>
          )}
        </div>
        <button onClick={toggleSidebar} className="collapse-button">
          <SidebarItem
            icon={ExtendScreen}
            label="Collapse Menu"
            isExpanded={isExpanded}
            className="siderbar-controll-button"
          />
        </button>
      </div>
    </div>
  );
}

export default Sidebar;
